var _rect, _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectCompletedIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#00AA55",
    fillOpacity: 0.14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8348 11.752C15.6688 11.752 10.6562 16.7645 10.6562 22.9305C10.6562 29.0966 15.6688 34.1091 21.8348 34.1091C28.0009 34.1091 33.0134 29.0966 33.0134 22.9305C33.0134 16.7645 28.0009 11.752 21.8348 11.752ZM21.8348 32.2977C16.6812 32.2977 12.4677 28.0842 12.4677 22.9305C12.4677 17.7769 16.6812 13.5634 21.8348 13.5634C26.9885 13.5634 31.202 17.7769 31.202 22.9305C31.202 28.0842 26.9885 32.2977 21.8348 32.2977Z",
    fill: "#00AA55",
    stroke: "#00AA55",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2854 25.1038L18.2572 23.0756L18.0783 22.8967L17.9015 23.0778L16.9812 24.0211L16.8079 24.1988L16.9843 24.3734L19.1419 26.5088V26.531L19.2151 26.6042L19.4912 26.8803L19.4912 26.8803L19.4946 26.8836L20.1158 27.4818L20.1884 27.5517H20.2086L20.3394 27.6825L20.5161 27.4973L27.2113 20.48L27.3841 20.2989L27.2027 20.1263L26.2594 19.229L26.0789 19.0573L25.9066 19.2372L20.2854 25.1038Z",
    fill: "#00AA55",
    stroke: "#00AA55",
    strokeWidth: 0.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCompletedIcon);
export default __webpack_public_path__ + "static/media/projectCompletedIcon.72104b87c2b7a5689ee0871bce7b5793.svg";
export { ForwardRef as ReactComponent };